module.exports = __webpack_public_path__ + "static/media/404.95cd88c8.svg";